import router from './router'
import store from './store'
import { getToken } from '@/utils/auth'

function isAuthRoute(path) {
  return path === '/mine' || path.startsWith('/publish')
}

router.beforeEach((to, from, next) => {
  const hasToken = !!getToken() || store.getters.isLoggedIn

  if (!isAuthRoute(to.path)) {
    next()
    return
  }

  if (hasToken) {
    next()
    return
  }

  next('/home')
  router.app.$nextTick(() => {
    router.app.$root.$emit('show-login')
  })
})
